import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1866.00282,351.563294 L1565.12753,50.5750588 C1495.66871,-17.0767059 1384.19576,-16.8508235 1316.20518,51.1397647 L906.228706,461.116235 C837.899294,529.558588 837.899294,640.805647 906.341647,709.248 L937.965176,740.871529 L1017.70165,660.909176 L986.078118,629.398588 C961.795765,605.003294 961.795765,565.360941 986.078118,540.965647 L1396.05459,130.989176 C1420.56282,106.593882 1460.88282,106.819765 1485.72988,130.989176 L1785.58871,430.960941 C1810.32282,456.146824 1810.43576,496.579765 1786.15341,520.975059 L1376.17694,930.951529 C1351.66871,955.233882 1312.02635,955.233882 1287.63106,930.951529 L1176.83576,820.043294 L1336.30871,660.683294 L1256.45929,580.833882 L820.845176,1016.33506 L711.066353,906.556235 C678.200471,872.899765 634.266353,854.264471 587.395765,853.925647 C543.800471,855.619765 495.122824,872.222118 461.240471,906.104471 L51.3769412,1316.08094 C-17.0654118,1384.52329 -17.0654118,1495.77035 51.3769412,1564.21271 L352.929882,1865.76565 C387.038118,1899.87388 431.988706,1917.04094 476.939294,1917.04094 C521.889882,1917.04094 566.840471,1899.87388 601.061647,1865.76565 L1011.03812,1455.78918 C1044.80753,1421.90682 1063.44282,1377.18212 1063.104,1329.74682 C1062.87812,1282.76329 1044.12988,1238.82918 1011.03812,1206.528 L980.544,1176.03388 L900.694588,1255.88329 L931.640471,1286.82918 C943.499294,1298.46212 950.049882,1313.93506 950.162824,1330.42447 C950.275765,1347.36565 943.499294,1363.51624 931.188706,1375.93976 L521.212235,1785.91624 C497.720471,1809.408 456.271059,1809.408 432.779294,1785.91624 L131.226353,1484.36329 C119.480471,1472.61741 113.042824,1456.91859 113.042824,1440.09035 C113.042824,1423.37506 119.480471,1407.67624 131.226353,1395.93035 L541.202824,985.953882 C553.400471,973.643294 569.438118,966.866824 586.266353,966.866824 L586.718118,966.866824 C603.207529,966.979765 618.680471,973.530353 630.652235,985.953882 L740.995765,1096.18447 L578.812235,1258.48094 L658.661647,1338.33035 L1096.98635,899.892706 L1207.78165,1010.80094 C1242.11576,1045.02212 1286.95341,1062.07624 1331.904,1062.07624 C1376.85459,1062.07624 1421.80518,1045.02212 1456.02635,1010.80094 L1866.00282,600.824471 C1933.88047,532.833882 1933.99341,421.360941 1866.00282,351.563294",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconLinkLine = /*#__PURE__*/function (_Component) {
  _inherits(IconLinkLine, _Component);

  var _super = _createSuper(IconLinkLine);

  function IconLinkLine() {
    _classCallCheck(this, IconLinkLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconLinkLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconLink",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconLinkLine.displayName = "IconLinkLine";
  return IconLinkLine;
}(Component);

IconLinkLine.glyphName = 'link';
IconLinkLine.variant = 'Line';
IconLinkLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconLinkLine;
export { IconLinkLine };